import { render, staticRenderFns } from "./PerbulanView.vue?vue&type=template&id=3ddf2429&scoped=true"
import script from "./PerbulanView.vue?vue&type=script&lang=js"
export * from "./PerbulanView.vue?vue&type=script&lang=js"
import style0 from "./PerbulanView.vue?vue&type=style&index=0&id=3ddf2429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf2429",
  null
  
)

export default component.exports